
import store from '@/store'
import wx from 'weixin-js-sdk'
import defautphoto from '@/assets/timg.jpg'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import { getConfig, addFile } from '@/api/wx.js'
import {
getUserQueryMainList,
pumpClinic,
accountDatadrid,
doctorDatadrid,
datadrid,
accountDialogue,
doctorDialogue,
doctorDelete,
getUserQueryDetailList,
replyClinic,
getDealCount,
deleteQuery
} from '@/api/pengchengxinli'
import config from '@/config/index'
import Scroll from '@/components/scroller'
export default {
directives: {
TransferDom
},
components: { Tab, TabItem, Popup, XTextarea, Badge, Scroll },
data () {
return {
show: false,
baseUrl: config.baseUrl,
defautphoto: defautphoto,
replyStatus: 2, // 2未解答1已解答 ****
doctorId: '', // 医生id
questionId: '', // 问题id
querystatus: 1, // 1未解答2已解答
clinictype: 3, // 全科门诊2体检报告解读
list: [],
querycontent: '',
mainid: '',
count1: 0, // 待处理数量
count2: 0, // 待处理数量
count3: 0, // 待处理数量
count: 0,
rows: 6,
page: 1,
notFirstLoad: false,
loadMoreDom: null,
photoObj: {
imgcount: 5,
imglist: [],
fileUrlArr: []
},
isShow: []
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},

userCertType () {
return this.$store.state.user.userCertType
}
},
mounted () {
this.wxconfig()
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')

this.getList()
},
methods: {













getList (type, done) {

if (this.userCertType === 2) {
accountDatadrid({
accountId: this.accountid,
replyStatus: this.replyStatus,
page: this.page,
rows: this.rows
}).then(res => {
if (res.success === true) {
if (type === 'refresh') {
this.list = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.obj
console.log(obj.length)
if (obj.length === 0 && this.page === 1) {
this.list = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
this.count += res.obj[0].num1
obj.forEach(item => {

this.isShow.push(false)
})
this.list = this.page === 1 ? obj : [...this.list, ...obj]


if (this.list.length === this.count) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
}
}).catch(() => {
this.notFirstLoad = true
done && done()
})
} else if (this.userCertType === 1) {
doctorDatadrid({
doctorId: 1025,

replyStatus: this.replyStatus,
page: this.page,
rows: this.rows
}).then(res => {
if (res.success === true) {

if (type === 'refresh') {
this.list = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.obj

if (obj.length === 0 && this.page === 1) {
this.list = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
this.count += res.obj[0].num1
obj.forEach(item => {
this.isShow.push(false)
})
this.list = this.page === 1 ? obj : [...this.list, ...obj]


if (this.list.length === this.count) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
}
}).catch(() => {
this.notFirstLoad = true
done && done()
})
}
},

onItemClick (index) {
if (this.replyStatus !== index + 1) {
this.listDom.scrollTop = 0
this.page = 1
this.replyStatus = index + 1
this.getList()
this.count = 0
}
},
changeType (val) {
if (this.clinictype !== val) {
this.listDom.scrollTop = 0
this.page = 1
this.clinictype = val
this.getList()
}
},

onAnswer (doctorId, questionId) {
this.show = true
this.doctorId = doctorId
this.questionId = questionId
},

onDelete (mainid) {
let _this = this
this.$vux.confirm.show({
title: '提示信息',
content: '确定要删除吗？',
onConfirm () {
doctorDelete({
accountid: _this.accountid,
id: mainid
}).then(res => {
if (res.success === true) {
_this.$vux.toast.text('删除成功')
_this.count = 0
_this.getList()
}
})
}
})
},

cancel () {
this.show = false
},

submit () {

if (this.querycontent === '') {
if (this.userCertType === 2) {
this.$vux.toast.text('请先填写追问内容')
} else if (this.userCertType === 1) {
this.$vux.toast.text('请先填写回复内容')
}
return false
}
let arr = this.photoObj.imglist.map(item => item.id)
let queryimgs = arr.join(';')
if (this.userCertType === 2) {

accountDialogue({
accountId: this.accountid,
doctorId: this.doctorId,
reply: this.querycontent,
picIds: queryimgs,
questionId: this.questionId
}).then(res => {
if (res.success) {
this.show = false
this.$vux.toast.text('提交成功')
this.count = 0
this.getList()
this.photoObj.imglist = []
this.photoObj.fileUrlArr = []
this.querycontent = ''
}
})
} else if (this.userCertType === 1) {

doctorDialogue({
accountId: this.accountid,
doctorId: this.doctorId,
reply: this.querycontent,
picIds: queryimgs,
questionId: this.questionId
}).then(res => {
if (res.success) {
this.show = false
this.$vux.toast.text('提交成功')


this.count = 0
this.getList()
this.photoObj.imglist = []
this.photoObj.fileUrlArr = []
this.querycontent = ''
}
})
}
},














changeDate (index) {
this.isShow.splice(index, 1, !this.isShow[index])
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getList('refresh', done)
this.count = 0
},

loadMore (done) {
this.page++
this.loadMoreDom.innerText = '加载中...'
this.getList('more', done)
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, imgcount) {

var _this = this
wx.chooseImage({
count: imgcount - imglist.length, // 默认5
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.uploadFile(imglist, localIds)
}
}
})
},

uploadFile (imglist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
_this.photoObj.fileUrlArr.push(re.returnValue.filepath)
_this.index++
_this.uploadFile(imglist, localIds)
})
}
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item.filepath)

wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
del (index) {
this.photoObj.imglist.splice(index, 1)
}
}
}
